import React, {Component} from 'react'
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    Row
} from "reactstrap";
import GCLogo from '../../assets/images/gc_desktop_icon.jpeg'
import {Redirect} from "react-router-dom";
import QrReader from 'react-qr-reader'
import Axios from "axios";
import {login, showError} from "../../API/API";
import {logPageView} from "../../AppHelpers/GoogleAnalytics";

class Device extends Component {

    state = {
        deviceName: '',
        email: '',
        password: ''
    };

    componentDidMount() {
        if (this.props.location.state) {
            this.setState({deviceName: this.props.location.state.deviceName})
        }
    }

    inputChangeHandler = key => (event) => {
        this.setState({[key]: event.target.value});
    };

    redirectHandler = () => {
        const {email, password, deviceName} = this.state;
        login({email, password})
            .then(({data: {data}}) => {
                localStorage.setItem('deviceName', deviceName);
                localStorage.setItem('token', data.api_token);
                Axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.api_token;
                this.props.history.push("/slider", this.state);
            })
            .catch(showError)
    };

    handleScan = data => {
        if (data) {
            const email = data.split('\n')[0];
            const password = data.split('\n')[1];
            const deviceName = data.split('\n')[2];
            this.setState({
                deviceName,
                email,
                password,
                modal: !data.split('\n')[2],
            }, this.redirectHandler);
        }
    }

    handleError = err => {
        console.error(err)
    }

    toggle = () => {
        this.setState(prevState => ({
            modal: !prevState.modal
        }),);
    }

    render() {
        if (localStorage.getItem('deviceName')) {
            return <Redirect to={{pathname: "/slider", state: {deviceName: localStorage.getItem('deviceName')}}}/>
        }

        logPageView('/');
        const {email, password, deviceName} = this.state;
        return (
            <div>
                <div className="w-100 d-flex justify-content-center blockquote p-2 header-bar">
                    <span className="text-black center display-50"><i className="fas fa-signature"></i> Green Cloud Signer Login</span>
                </div>
                <Container>
                    <Row style={{justifyContent: "center", marginTop: "40px"}}>
                        <Col className="order-xl-1" xl="8">
                            <Card>
                                <CardHeader className="bg-white border-0">
                                    <Row className="align-items-center">
                                        <img src={GCLogo} style={{
                                            'max-height': '150px',
                                            'margin-left': 'auto',
                                            'margin-right': 'auto'
                                        }}/>
                                        <p className={'padding-15 text-center'}>Green Cloud Sign is an Electronic
                                            Receipts signing tool created by Variant IT Solutions for businesses that
                                            want to go paperless.</p>
                                    </Row>
                                    <Row className="align-items-center">
                                        <Col xs="8">
                                            <h3 className="mb-0">Device Setup</h3>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>

                                    <Modal size="xl" isOpen={this.state.modal} toggle={this.toggle}
                                           className="qr-modal">
                                        <ModalBody id="modal"
                                                   className="modal-height d-flex justify-content-center">
                                            <QrReader
                                                delay={300}
                                                onError={this.handleError}
                                                onScan={this.handleScan}
                                                style={{width: '100%', maxWidth: 370}}
                                            />
                                        </ModalBody>
                                        <ModalFooter className="justify-content-between">
                                            <Button style={{backgroundColor: 'rgba(207, 207, 207, 1)', color: "black"}}
                                                    onClick={this.toggle}>Cancel</Button>{' '}
                                            <Button style={{backgroundColor: 'rgba(207, 207, 207, 1)', color: "black"}}
                                                    onClick={this.saveSignature}> Save
                                            </Button>
                                        </ModalFooter>
                                    </Modal>
                                    <Form onSubmit={(e) => e.preventDefault()}>
                                        <Col lg="12">
                                            <FormGroup>
                                                <label className="form-control-label">
                                                    Enter User Name
                                                </label>
                                                <Input type="text" onChange={this.inputChangeHandler('email')}
                                                       value={this.state.email}
                                                       autoComplete="on"
                                                       className="form-control" placeholder="User Name"/>
                                            </FormGroup>
                                            <FormGroup>
                                                <label className="form-control-label">
                                                    Enter Password
                                                </label>
                                                <Input type="password" onChange={this.inputChangeHandler('password')}
                                                       value={this.state.password}
                                                       className="form-control" placeholder="Password"/>
                                            </FormGroup>
                                            <FormGroup>
                                                <label className="form-control-label">
                                                    Enter Device Name
                                                </label>
                                                <Input type="text" onChange={this.inputChangeHandler('deviceName')}
                                                       value={this.state.deviceName}
                                                       autoComplete="on"
                                                       className="form-control" placeholder="Device Name"/>
                                            </FormGroup>
                                        </Col>
                                        <Col lg="12">
                                            <label className="form-control-label">
                                                or
                                            </label>
                                        </Col>
                                        <Col lg="12">
                                            <FormGroup>
                                                <Button onClick={this.toggle}>
                                                    <i className="fas fa-qrcode"></i> Scan QR code.
                                                </Button>
                                            </FormGroup>
                                        </Col>
                                        <hr/>
                                        <Row className="justify-content-center p-2 m-2">
                                            {/* <Link to={{ to: "/slider", state: this.state.deviceName }} className="btn btn-primary">Next</Link> */}
                                            <button className="btn btn-primary"
                                                    disabled={!deviceName || !email || !password}
                                                    onClick={this.redirectHandler}>
                                                <i className="fas fa-sign-in-alt"></i> Sign In
                                            </button>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default Device;
